export const getEventInfo = (type, url, installationServiceName) => {
  const internalLinkURL = url
    ? (url.indexOf("http") === -1 ? window.location.origin : "") + url
    : "n/a"
  return JSON.stringify({
    eventAction: `pdp:cross-sell:kohler professional services:${type}`,
    eventName: `pdp:cross-sell:kohler professional services:${type}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "change",
    internalLinkPosition: "pdp",
    internalLinkType: `pdp:${installationServiceName?.toLowerCase()}`,
    internalLinkURL,
    internalLinkZoneName: "pdp:cross-sell:kohler professional services",
    clickInternalLinks: "true",
  })
}

export const addDataLayerOnCheckAvailability = (
  errMessage,
  installationServiceName,
  checkZipCode,
  productInfo
) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  // const installationServiceName =
  //   installationServiceData?.sectionHeading || ""
  const eventInfo = {
    eventAction:
      "pdp:cross-sell:kohler professional services:check availability",
    eventName: "pdp:cross-sell:kohler professional services:check availability",
    eventType: "navigation",
    eventMsg: errMessage ? errMessage.toLowerCase() : "n/a",
    eventStatus: errMessage ? "failure" : "success",
    internalLinkName: "search",
    internalLinkPosition: "pdp",
    internalLinkType: `pdp:${installationServiceName?.toLowerCase()}:${checkZipCode}`,
    internalLinkURL: "n/a",
    internalLinkZoneName: "pdp:cross-sell:kohler professional services",
    clickInternalLinks: "true",
  }

  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    productInfo,
    page,
  })
}
